import { render, staticRenderFns } from "./ImpactCard.vue?vue&type=template&id=5645162e&"
import script from "./ImpactCard.vue?vue&type=script&lang=js&"
export * from "./ImpactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5645162e')) {
      api.createRecord('5645162e', component.options)
    } else {
      api.reload('5645162e', component.options)
    }
    module.hot.accept("./ImpactCard.vue?vue&type=template&id=5645162e&", function () {
      api.rerender('5645162e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/impactcard/ImpactCard.vue"
export default component.exports